import { Toggle } from "@velocity-ehs/component-library";
import { useMemo, useState } from "react";
import classes from "./RolesPage.module.scss";

interface RowData {
  id: string;
  name: string;
  description: string;
  scope: { id: string; name: string } | Array<{ id: string; name: string }>;
  permissions: Array<{ id: string }>;
}

const Description = (data: RowData) => (
  <span className={classes.truncateMultiLine}>{data.description}</span>
);

const Scope = (data: RowData) => {
  if (!Array.isArray(data.scope)) {
    return <span>{data.scope?.name}</span>;
  }

  if (data.scope?.length === 0) {
    return;
  }

  if (data.scope?.length === 1) {
    return <span>{data.scope[0].name}</span>;
  }

  return <span>Mixed</span>;
};

const Assigned = ({
  data,
  assignedPolicies,
  setState,
  readOnly,
}: {
  data: RowData;
  assignedPolicies: Array<{ id: string }>;
  setState: (data: { id?: string; name?: string; value: boolean }) => void;
  readOnly?: boolean;
}) => {
  const [checked, setChecked] = useState(false);

  useMemo(() => {
    assignedPolicies
      ?.map((policy) => policy.id)
      .forEach((policyId) => {
        if (policyId === data.id) {
          return setChecked(true);
        }
      });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [assignedPolicies]);

  const handleChecked = (data: {
    target: { id?: string; name?: string; value: boolean };
  }) => {
    setState(data.target);

    setChecked((prev) => !prev);
  };

  return (
    <Toggle
      id={data.id}
      name={data.name}
      checked={checked}
      onChange={handleChecked}
      disabled={readOnly}
    />
  );
};

export type { RowData };
export const TableBodies = {
  Assigned,
  Scope,
  Description,
};
